module.exports = __webpack_public_path__ + "img/orb-2.2fc0908d.svg";